export default "__VITE_ASSET__5a26e65e__"